/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
export const environment = {
  production: true,
  apiUrl: 'https://localhost:8000/api',
  defaultLang: 'en',
  buildInfo: {
    date: '2026-08-11',
    version: 'v2.3.0.7',
    pipelineRun: '2026-08-11.03'
  },
};
